import React, { Component } from 'react';
import { getNavigationItems } from './app-navigation';
import './App.scss';
import { getScreenSize, subscribe, unsubscribe } from './utils/media-query';
import { logInfo } from './utils/utils';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Footer, Header } from './components'
import { BrowserRouter, Routes, Route } from 'react-router-dom';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      screenSizeClass: this.getScreenSizeClass(),
      navigationItems: [],
    };

    this.authPageRef = React.createRef();
  }

  componentDidMount() {
    this.loadNavigationPages();
    subscribe(this.screenSizeChanged);
  }

  loadNavigationPages = () => {
    const navigationItems = getNavigationItems();

    this.setState({
      navigationItems: navigationItems.filter((i) => { return i.enabled; }),
    });
  }

  componentWillUnmount() {
    unsubscribe(this.screenSizeChanged);
    unsubscribe(this.pageUpdateEvent);
  }

  pageUpdateEvent = (event, args) => {
    logInfo(`Event '${event}' raised`);

    this.loadNavigationPages();
  }

  render() {
    const { navigationItems } = this.state;

    return (
      <div>
        <BrowserRouter>
          <Header navigationItems={navigationItems} />
          <div>
            <Routes>
              {navigationItems.map(item => (
                <Route
                  path={`/${item.path}`}
                  element={
                    <item.component />
                  }
                />
              ))}
            </Routes>
          </div>
          <Footer />
        </BrowserRouter>
      </div>
    );
  }

  getScreenSizeClass() {
    const screenSizes = getScreenSize();
    return Object.keys(screenSizes).filter(cl => screenSizes[cl]).join(' ');
  }

  screenSizeChanged = () => {
    this.setState({
      screenSizeClass: this.getScreenSizeClass()
    });
  }

  menuItemClicked = (args) => {
    if (!args || !args.text)
      return;

    window.location.href = `/#${args.path}`;
  };
}

export default App;